<!--
 * @Descripttion: 
 * @version: 
 * @Author: yql
 * @Date: 2019-12-11 13:48:14
 * @LastEditors: yql
 * @LastEditTime: 2020-04-29 08:58:04
 -->
<template>
  <div class="changePhone" id="modifyPwd">
    <h4 style="margin-bottom: 18px;">修改密码</h4>
    <div class="formBox">
      <div class="formUnit">
        <div class="label">电话号码</div>
        <div class="inputBox">
          <div class="inputer ">
            <input
              type="text"
              class="gray"
              @blur="trims"
              readonly
              placeholder="请输入电话号码"
              v-model="submitMode.mobile"
              value=""
            />
          </div>
        </div>
        <div class="label">旧密码</div>
        <div class="inputBox">
          <div class="inputer ">
            <input
              type="password"
              class="gray"
              @blur="trims"
              placeholder="请输入旧密码"
              v-model="submitMode.password"
              value=""
            />
          </div>
        </div>
        <div class="label">新密码</div>
        <div class="inputBox">
          <div class="inputer ">
            <input
              type="password"
              class="gray"
              @blur="trims"
              placeholder="请输入新密码"
              v-model="submitMode.newPassword"
              value=""
            />
          </div>
        </div>
      </div>

      <div class="btnAreaBox">
        <div class="btnDiv">
          <button class="btn" @click="submitEvent()">保存</button>
        </div>
      </div>
    </div>

    <view-footer></view-footer>
  </div>
</template>
<script>
export default {
  name: "modifyPwd",
  data() {
    return {
      submitMode: {
        password: "",
        newPassword: "",
        mobile: ""
      }
    };
  },
  mounted() {},
  created() {
    this.getMainList();
  },
  methods: {
    //获取主列表
    getMainList() {
      this.load.$emit("loading", true);
      this.$store
        .dispatch("property/userInfo", {})
        .then(result => {
          this.load.$emit("loading", false);
          if (result.returnCode == 0) {
            this.submitMode.mobile = result.data.mobile;
          } else {
            this.$confirm({
              mesg: result.returnMsg,
              cancel: false,
              btn: {
                confirmVal: "确 定"
              }
            });
          }
        })
        .catch(error => {
          this.load.$emit("loading", false);
          if (error.message.includes("timeout")) {
            this.$confirm({
              mesg: "数据请求超时",
              cancel: false,
              btn: {
                confirmVal: "确 定"
              }
            });
          }
        });
    },
    //提交
    submitEvent() {
      if (this.submitMode.password === "" || this.submitMode.password == null) {
        this.$confirm({
          mesg: "请输入旧密码",
          cancel: false,
          btn: {
            confirmVal: "确 定"
          }
        });
        return false;
      } else if (
        this.submitMode.newPassword === "" ||
        this.submitMode.newPassword == null
      ) {
        this.$confirm({
          mesg: "请输入新密码",
          cancel: false,
          btn: {
            confirmVal: "确 定"
          }
        });
        return false;
      }
      this.$store
        .dispatch("user/modifyPwd", this.submitMode)
        .then(result => {
          if (result.returnCode == 0) {
            this.$toast.success("密码修改成功");
            this.$router.push("/account");
          } else {
            this.$confirm({
              mesg: result.returnMsg,
              cancel: false,
              btn: {
                confirmVal: "确 定"
              }
            });
          }
        })
        .catch(error => {
          this.load.$emit("loading", false);
          if (error.message.includes("timeout")) {
            this.$confirm({
              mesg: "请求超时",
              cancel: false,
              btn: {
                confirmVal: "确 定"
              }
            });
          }
        });
    }
  }
};
</script>
